var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showError),expression:"showError"}],staticClass:"error-message"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.errorText))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }